module.exports = __webpack_public_path__ + "static/media/map.0f2d42c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map.png
// module id = 1604
// module chunks = 0